import { deleteRest, get, post } from 'utils/rxfetch'

export default () => ({
  validateSession() {
    return get('/members-api/new-signin/')
  },
  useOtherCredentials() {
    return deleteRest('/members-api/new-signin/')
  },
  submitLogin(body) {
    return post('/members-api/new-signin/', body)
  },
  submitExpiredPass(body) {
    return post('/members-api/password-expired/', body)
  },
  submitSSO(body) {
    return post('/members-api/sso-login/', body)
  },
  submitEULA(body) {
    return post('/members-api/confirm-eula/', body)
  },
  submitFirstLogin(data) {
    return post('/members-api/first-tenant-login/', data)
  },
  fetch2FA() {
    return get('/members-api/tfa-login/')
  },
  submit2FA(body) {
    return post('/members-api/tfa-login/', body)
  },
})
